/**
 * ModeSwitcher — toggle between single-match and bulk-ranking modes.
 *
 * Stateless segmented control. Parent owns the mode state.
 */

import { FileText, Users } from "lucide-react";

export type MatchMode = "single" | "bulk";

interface Props {
  mode: MatchMode;
  onChange: (mode: MatchMode) => void;
}

export function ModeSwitcher({ mode, onChange }: Props) {
  return (
    <div className="inline-flex rounded-lg border border-slate-800/70 bg-slate-900/40 p-1">
      <Button
        active={mode === "single"}
        onClick={() => onChange("single")}
        icon={<FileText className="w-3.5 h-3.5" />}
        label="Single match"
      />
      <Button
        active={mode === "bulk"}
        onClick={() => onChange("bulk")}
        icon={<Users className="w-3.5 h-3.5" />}
        label="Bulk ranking"
      />
    </div>
  );
}

function Button({
  active,
  onClick,
  icon,
  label,
}: {
  active: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition ${
        active
          ? "bg-slate-800 text-slate-100 shadow-sm"
          : "text-slate-500 hover:text-slate-300"
      }`}
    >
      {icon}
      {label}
    </button>
  );
}
